import { useState, useEffect } from 'react'
import { getToken, getUserData } from '@utils'

export const useUser = () => {
  const [userData, setUserData] = useState<any>(null)

  useEffect(() => {
    const token = getToken()
    const _userData = getUserData(token)
    if (_userData) setUserData(_userData)
  }, [])

  return { userData, setUserData }
}
